import { ReactNode } from 'react';

import { Text } from 'farmhub-ui-core';

import { TickIcon } from 'components/Icon';

import { IconWrapper, Wrapper } from './styles';

type ProductSelectedProps = {
  icon: ReactNode;
  title: string;
  selected: boolean;
};

const ObjectSelectItem = ({ icon, title, selected }: ProductSelectedProps) => (
  <Wrapper selected={selected}>
    <IconWrapper>{icon}</IconWrapper>
    <Text
      color="secondary"
      size="xxs"
      styles={{ display: 'block', textAlign: 'center' }}
      weight="bold"
    >
      {title}
    </Text>
    <div className="tick">
      <TickIcon color="#fff" width={12} />
    </div>
  </Wrapper>
);

export default ObjectSelectItem;
